<template>
  <div>
    <Splide
      ref="$splide"
      class=""
      :has-track="true"
      :options="splideConfig"
      @splide:move="onMove"
    >
      <!-- 648x352 -->
      <SplideSlide
        v-for="(slide, idx) in slides"
        :key="idx"
        class="flex items-center justify-center h-auto w-full"
      >
        <NuxtPicture
          v-if="!hasError"
          fit="inside"
          placeholder
          class="w-full flex items-center justify-center h-full cursor-zoom-in"
          sizes="sm:40vw lg:50vw 100vw"
          quality="90"
          loading="lazy"
          alt="imagen del coche"
          :img-attrs="{ class: 'lg:aspect-3/2 object-cover w-full h-full max-w-[648px] sm:min-h-auto md:min-h-[352px] rounded-md' }"
          :src="slide"
          @load="onLoadImage"
          @click="sliderVisible = true"
        />

        <BaseImagePlaceholder v-if="hasError" title="no image" />
      </SplideSlide>
    </Splide>

    <nav v-if="slides.length && firstImageLoaded" class="my-3 flex gap-3 items-center snap-x snap-mandatory overflow-x-auto pb-4 px-0.5 pt-2">
      <button
        v-for="(slide, idx) in slides"
        :key="idx"
        :class="idx === activeItem && 'outline-2 outline outline-brand-primary shadow-md shadow-brand-primary'"
        :aria-selected="idx === activeItem ? 'true' : 'false'"
        type="button"
        class="rounded-md relative hover:opacity-75 transition-opacity duration-300 flex-1 snap-center shrink-0"
        @click="goToSlide(idx)"
      >
        <BaseImage
          :src="slide"
          class="aspect-3/2 h-auto object-cover rounded-md min-h-[4rem] min-w-[6rem]"
          placeholder
          loading="lazy"
          quality="50"
        />
      </button>
    </nav>

    <CarDetailsImageSliderModal v-model:open="sliderVisible" :slides="slides" />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { SplideSlide, Splide } from '@splidejs/vue-splide';
import BaseImage from '~/components/BaseImage.vue';
import BaseImagePlaceholder from '~/components/BaseImagePlaceholder.vue';
import CarDetailsImageSliderModal from '~/components/car-details/image-slider/CarDetailsImageSliderModal.vue';

const firstImageLoaded = ref(false);
const activeItem = ref(-1);
const hasError = ref(false);
const sliderVisible = ref(false);

function onLoadImage () {
  firstImageLoaded.value = true;
  activeItem.value = 0;
}

interface Props {
  slides: string[]
}

const props = defineProps<Props>();

const $splide = ref(null) as any;
const splideConfig = {
  perPage: 1,
  type: 'fade',
  arrows: false,
  pagination: false,
  autoplay: false,
  rewind: true,
};

function goToSlide (index: number) {
  $splide.value.go(index);
}

function onMove (_: unknown, activeIndex: number) {
  activeItem.value = Number(activeIndex);
}

function checkImage (url: string) {
  const img = new Image();
  img.onload = function () {
    hasError.value = false;
    onLoadImage();
  };
  img.onerror = function () {
    hasError.value = true;
  };
  img.src = url;
}

onMounted(() => {
  checkImage(props.slides?.[0] || '');
});
</script>
